import { api_url } from "../../utils/constants";
const axios = require('axios').default;

// progress: { pose, takenOn, trainerId } for the "StringsSG Progress" album; the response
// then carries what the photo earned (reward)
export const uploadImage = (file, userId, userFullNm, caption, albumName, albumPrivacy, postSecurity, desc, progress) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('file', file);
        fdd.append('userId', userId);
        fdd.append('userFullNm', userFullNm);
        fdd.append('caption', caption);
        fdd.append('fileType', file.type);
        fdd.append('albumName', albumName);
        fdd.append('albumPrivacy', albumPrivacy);
        fdd.append('postSecurity', postSecurity);
        fdd.append('desc', desc);
        if (progress?.pose) fdd.append('pose', progress.pose);
        if (progress?.takenOn) fdd.append('takenOn', progress.takenOn);
        if (progress?.trainerId) fdd.append('trainerId', progress.trainerId);

        axios({
          method : "POST",
          url :  api_url + "/UploadImage",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}